// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { GET_PAST_VISIT_INFO_SUCCESS } from './PastVisitConstants'
import { getPastVisitPrescriptionInfo } from './PastVisitThunk'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const PastVisitListener = ({ visitId }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
        effect: async (action, listenerApi) => {
          switch (action.type) {
            case GET_PAST_VISIT_INFO_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.visitId === visitId) {
                getPastVisitPrescriptionInfo(visitId)
              }
              break
            default:
              break
          }
        },
      }),
    )
    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [])

  return null
}
